import { render, staticRenderFns } from "./TagsExpanded.vue?vue&type=template&id=13727d01"
import script from "./TagsExpanded.vue?vue&type=script&lang=js"
export * from "./TagsExpanded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports